export const UNLIMITED_ACCESS_LIMIT = -1
export const NO_ACCESS_LIMIT = 0
export const INDEFINITE_TIMEFRAME = 'indefinite'
